export const stepCounter_sv = {
  'step_settings' : 'Steginställningar',
  'stepcounter': 'Stegräknare',
  'stepcounter_access_info': 'Sätt ett dagligt mål och se stegstatistik. Slå på appens stegräknare för att tillåta att dina steg räknas kontinuerligt, även när appen är stängd.',
  'stepcounter_is' : 'Stegräknaren är ',
  'active': 'aktiverad',
  'not_active': 'avstängd',
  'stepcounter_onoff': 'Slå på/av stegräknaren',
  'add_daily_goal' : 'Sätt ett daligt steg mål',
  'daily_goal': 'Dagligt mål:',
  'change_daily_goal' : 'Ändra dagligt mål',
  'active_info' : 'Aktivera stegräknaren för att komma igång och börja räkna dina steg i appen!',
  'updated' : 'Uppdaterad',
  'reached_goals' : 'Uppnådda mål',
  'steps' : 'Steg',

  'steps_per_h': 'Steg per timme',
  'hour' : 'Timme',
  'stepsday' : 'Steg/Dag',
  'chosen_value': 'Valt mål:',

  'active_challenge' : 'Aktiv utmaning',
  'no_active_challenge' : 'Ingen aktiv utmaning för tillfället',
  'distance_done' : 'Distans avklarad',
  'route' : 'Rutt',
  'active_persons' : 'Aktiva medlemmar',

  'total_steps' : 'Alla steg:',
  'total_walks' : 'Alla promenader:',
  'booked_walks' : 'Bokade promenader:',
  'created_walks' : 'Skapade promenader:',
  'stepcounter_enabled' : 'Stegräknare på',
  'stepcounter_disabled' : 'Stegräknare av',
  'goal' : 'Mål',
  'view_steps' : 'Se steg-data',
  'activate_steps' : 'Aktivera stegräknaren',
  'leaderboard' : 'Ledartavla',
  'leaderboard_info' : 'Tävla mot andra tillsammans med ditt lag',
  'all_challenges' : 'Alla utmaningar',
  'view_challenge_history' : 'Se din utmanings-historik',

  'activity_challenges' : 'Aktivitetsutmaningar',
  'no_challenge' : 'Hittade ingen utmaning',
  'handle_stepcounter' : 'Hantera stegräknaren',
  'open_settings' : 'Öppna inställningar',
  'not_available' : 'Inte tillgänglig',

  'get_started_steps' : 'Kom igång och räkna dina steg i appen',
  'allow_permission' : 'Tillåt åtkomst',
  'step_one_steps' : 'Öppna appens inställningar, gå till "Behörigheter" och tillåt appen åtkomst för "Fysisk aktivitet".',
  'reload_app' : 'Ladda om appen',
  'reload_app_info' : 'Ladda om appen eller tryck på knappen nedan för att komma igång och räkna steg',
  'step_only_app' : 'Du kan endast tillåta stegräkning från appen, ej i webb',
  'manage_stepcounter' : 'Hantera stegräknaren',

  'personal_activity' : 'Personlig aktivitet',
  'daily_step_average' : 'Dagligt snitt:',
  'distance_left' : 'Sträcka kvar:',
  'more_stats' : 'Mer statistik',
  'details' : 'Detaljer',
  'activity_challenge' : 'Aktivitetsutmaning',
  'days_left' : 'Dagar kvar:',
  'could_not_load': 'Kunde inte ladda utmaningen',
  'steps_done' : 'Du har klarat ',
  'steps_percentage' : ' % av stegmålet',

  'my_orgs' : 'Visa bara min organisation',
  'team_average' : 'Team snitt',
  'week_average' : 'Veckans snitt:',
  'week_team_average' : 'Veckans team snitt:',
  'week_total_step' : 'Veckans steg total',
}